import styled from 'styled-components'
import { GTR } from '@farewill/ui/tokens'

// side-by-side fields always sit GTR.S apart, which a grid can't
// guarantee inside a Section (its gap is GTR.M) or next to a
// fixed-width field
export const FieldRow = styled.div`
  display: flex;
  gap: ${GTR.S};
`

export const FieldRowItem = styled.div`
  flex: 1;
  min-width: 0;
`

export const TitleFieldRowItem = styled.div`
  width: 90px;
  flex-shrink: 0;
`
